export default __webpack_public_path__ + "static/media/credit-card.dcf78975.svg";